define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/ProductTypeModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, ProductTypeModel, UserContext) {
    "use strict";
    var ProductTypes = /** @class */ (function () {
        function ProductTypes() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,ProductType.Edit,ProductType.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,ProductType.Delete"));
            this.editModel = ko.observable(new ProductTypeModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        ProductTypes.prototype.init = function () {
            var self = this;
            $("#page-title").text("Product Types");
            tools.ajaxGet({
                url: "/ProductType/GetProductTypesLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initProductTypes(self.lookupLists.GridStructures.ProductTypeStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        ProductTypes.prototype.initProductTypes = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            });
            var gridId = "productTypeTable";
            self.ProductTypeTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    toolbar: kendo.template($("#product-type-toolbar-template").html())
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/ProductType/GetProductTypes",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "ProductType",
                    title: "Product Types",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.ProductTypeTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.ProductTypeTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editProductType(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteProductTypeConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        ProductTypes.prototype.editProductType = function (id) {
            var self = this;
            var title = id > 0 ? "Edit Product Type" : "Add Product Type";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Name is required");
                        return;
                    }
                    if (self.multipleProviderSelector.value().length === 0) {
                        tools.error("At least one Provider is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveProductType(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/ProductType/GetProductTypeById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new ProductTypeModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new ProductTypeModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'product-type-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        self.multipleProviderSelector = $("#Providers", modal).kendoMultiSelect({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            placeholder: "Select Providers...",
                            dataTextField: "Text",
                            dataValueField: "Value",
                            autoClose: false,
                            dataSource: {
                                data: self.lookupLists.PhoneNumberProviders
                            }
                        }).data("kendoMultiSelect");
                        self.multipleProviderSelector.value(self.editModel().Providers());
                    });
                }
            });
        };
        ProductTypes.prototype.saveProductType = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj.ProviderIds = self.multipleProviderSelector.value().map(function (item) { return "-".concat(item, "-"); }).join();
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ProductType/SaveProductType",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.ProductTypeTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ProductTypes.prototype.deleteProductTypeConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Product Type",
                text: 'Are you sure you want to delete product type "' + name + '"?',
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteProductType(id);
            });
        };
        ProductTypes.prototype.deleteProductType = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ProductType/DeleteProductTypeConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Product type deleted successfully");
                    self.ProductTypeTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        ProductTypes.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        ProductTypes.prototype.exportTo = function () {
            var self = this;
            self.ProductTypeTable.exportTo();
        };
        ProductTypes.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("ProductType");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return ProductTypes;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/ProductType/Index")) {
            log.log("Initialize Product Type");
            $(function () {
                (new ProductTypes()).init();
            });
        }
    }, 0);
    return ProductTypes;
});
//# sourceMappingURL=productTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/productTypes.js
// module id = 224
// module chunks = 2